import React, { useEffect, useState } from 'react';
import Pagination from '../../../components/pagination';
import { searchWithdrawls, deletePromotion } from '../../../api/sportaloka-client';
import { format } from 'date-fns';
import Swal from 'sweetalert2';
import { getWithdrawStatusColor, getWithdrawStatusLabel } from '../../../helpers/status';
import FilterModal from './FilterData';
import WithdrawBalanceModal from './WithdrawBalanceModal';
import { Link } from 'react-router-dom';

function WithdrawlTable({ onFilterLengthChanged, bankAccounts, onSubmmited }) {
  const [paginationOptions, setPaginationOptions] = useState({
    page: 1,
    limit: 10,
    sort_field: 'created_at',
    sort_value: 'desc',
    date: '',
    status: ['NEW', 'PROCESS', 'DECLINED', 'DONE']
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const handlePageChange = (page) => {
    setPaginationOptions({ ...paginationOptions, page });
  };

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  const handleSubmit = () => {
    setPaginationOptions({ ...paginationOptions, page: 1 });
    onSubmmited();
  };

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setData([]);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit,
        sort_field: paginationOptions.sort_field,
        sort_value: paginationOptions.sort_value,
        status: paginationOptions.status,
        ...(paginationOptions.date && { date: paginationOptions.date })
      }).toString();
      const response = await searchWithdrawls(query);
      const responseData = response.data.data.data;
      setData(responseData);
      setTotalRows(response.data.data.total_rows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const handleFilter = (status, date) => {
    const filterLength = date ? 1 : 0;
    setPaginationOptions({ ...paginationOptions, status, date });
    onFilterLengthChanged(filterLength + status.length);
  };

  return (
    <div className="overflow-scroll scroll-bar-1 mb-20">
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th>Jumlah Penarikan</th>
            <th>Jumlah</th>
            <th>Fee</th>
            <th>Status</th>
            <th>Rekening Bank</th>
            <th>Tanggal Penarikan</th>
            <th className="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="6">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data.length === 0 && !error && (
            <tr>
              <th className="text-center" colSpan="6">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="6">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={getData}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data.map((row) => (
            <tr key={row.id}>
              <td className="text-left">
                {row && format(new Date(row.created_at), 'dd/MM/yyyy HH:MM:ss')}
              </td>
              <td className="text-left">IDR {row && row.amount.toLocaleString('id-ID')}</td>
              <td className="text-left">IDR {row && row.fee_amount.toLocaleString('id-ID')}</td>
              <td className="text-left">
                <div
                  style={{ width: 'auto', display: 'inline-block' }}
                  className={`py-1 px-3 text-center text-12 rounded-1 fw-600 ${getWithdrawStatusColor(row.status)}`}>
                  {row && getWithdrawStatusLabel(row.status)}
                </div>
              </td>
              {row.bank ? (
                <td className="text-left">
                  {row && `${row.bank.bank_name} - ${row.bank.account_number}`}
                </td>
              ) : (
                <td className="text-left">-</td>
              )}
              <td className="text-left">
                {row && format(new Date(row.updated_at), 'dd/MM/yyyy HH:MM:ss')}
              </td>
              <td className="text-center">
                <Link to={`/withdrawl/detail/${row.id}`}>
                  <span className="fa fa-eye text-18 text-primary cursor-pointer" />
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <FilterModal onFilter={handleFilter} />
      <WithdrawBalanceModal onSubmitted={handleSubmit} bankAccounts={bankAccounts} />
      <Pagination
        currentPage={paginationOptions.page}
        totalRows={totalRows}
        rowsPerPage={paginationOptions.limit}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

export default WithdrawlTable;
